import React from 'react';
import styled from 'styled-components';

import logo from '../assets/logo.png';

export const [logoSrc, logoLoginSrc, logoSidebarSrc, faviconSrc] = [
  logo,
  logo,
  logo,
  logo,
];

const WrapperHTML = ({ padding, ...props }) => <div {...props} />;

const Wrapper = styled(WrapperHTML)`
  display: flex;
  width: 100%;
  transform-origin: center;
  align-items: center;
  justify-content: center;
  #sidebar & {
    transform: scale(1);
  }
  #admin[data-is-tablet="true"] #sidebar & {
    display: none;
  }

  margin: auto;
  margin: -30px 0;

  /* Collapsed sidebar */
  .ant-layout-sider-collapsed & {
    margin: 10px 0 20px;
  }
`;

const LogoImage = styled.div`
  width: 100%;
  aspect-ratio: 1 / 1;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: ${({ type, theme }) => {
    switch (type) {
      case 'login':
        return `url(${theme.logoLogin || logo})`;
      case 'sidebar':
        return `url(${theme.logoSidebar || logo})`;
      default:
        return `url(${theme.logoSidebar || logo})`;
    }
  }};

  /* Collapsed sidebar - make logo bigger */
  .ant-layout-sider-collapsed & {
    width: 50px;
    height: 50px;
  }
`;

export default function Logo({ type, ...props }) {
  return (
    <Wrapper {...props}>
      <LogoImage type={type} />
    </Wrapper>
  );
}

export function renderLogo() {
  return <Logo type="login" />;
}

export function renderSidebarLogo({ expandedSidebar }) {
  return (
    <Logo
      type="sidebar"
      padding={expandedSidebar ? '50px' : '30px 20px 20px'}
    />
  );
}
